export default "__VITE_PUBLIC_ASSET__9023cfcb__"